// Campus photo for /colleges/berry-college: CC BY 3.0, by Froggerlaura, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AMary_Hall_at_Berry_College.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/berry-college/; credited under the photo.
const photo = {
    "slug": "berry-college",
    "alt": "Mary Hall, a stone Gothic building with a tower, behind its lawn and walkway at Berry College in Mount Berry, Georgia",
    "src": "/colleges/berry-college/campus-1600.webp",
    "srcSmall": "/colleges/berry-college/campus-800.webp",
    "srcMid": "/colleges/berry-college/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/berry-college/og.jpg",
    "title": "Mary Hall at Berry College",
    "author": "Froggerlaura",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AMary_Hall_at_Berry_College.jpg",
    "read": "2026-10-01"
};

export default photo;
